import React, {lazy, Suspense, useState} from 'react';
import PropTypes from 'prop-types';
import {ICON_ONLY, ICON_LABEL, LABEL_ONLY} from '@functions/const/floatLauncherButton';
import LauncherIcon from '@assets/components/Launcher/LauncherIcon';
import './Launcher.scss';
import {sizeMapping} from '@assets/const/popupSize';

// mostly use launcher icon, so we only need to lazy load the label
const LauncherLabel = lazy(() => import('@assets/components/Launcher/LauncherLabel'));

const buttonDefaultSettings = {
  iconColor: '#c1c1c1',
  labelWidth: '155px',
  buttonWidth: '25px',
  buttonHeight: '25px'
};

export default function FAQLauncher({
  i18n,
  type,
  settings,
  isCustomSize = false,
  isLauncherSelected = true,
  isLabelChanged = false
}) {
  const [open, setOpen] = useState(false);
  const {btnPopupColor, floatBtnSize, floatBtnLabel} = settings;
  const {labelWidth, buttonWidth, buttonHeight, iconColor} = buttonDefaultSettings;

  const maxWidth = isCustomSize ? 'none' : labelWidth;
  const minWidth = isCustomSize ? sizeMapping[floatBtnSize] : buttonWidth;
  const height = isCustomSize ? sizeMapping[floatBtnSize] : buttonHeight;
  const backgroundColor = isLauncherSelected ? btnPopupColor : iconColor;

  return (
    <div
      className={`Avada-Launcher__ButtonCustom Avada-Launcher__Button--${type}`}
      style={{height, minWidth, maxWidth, backgroundColor}}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {[ICON_ONLY, ICON_LABEL].includes(type) && (
        <LauncherIcon
          {...{
            settings,
            isCustomSize,
            iconWidth: minWidth,
            iconHeight: height,
            iconColor: backgroundColor
          }}
        />
      )}
      {[LABEL_ONLY, ICON_LABEL].includes(type) && floatBtnLabel && (
        <Suspense fallback={<div />}>
          <LauncherLabel
            {...{isCustomSize, isLabelChanged, isLauncherSelected, settings, i18n, open}}
          />
        </Suspense>
      )}
    </div>
  );
}

FAQLauncher.propTypes = {
  i18n: PropTypes.func,
  type: PropTypes.string,
  settings: PropTypes.object,
  isCustomSize: PropTypes.bool,
  isLauncherSelected: PropTypes.bool,
  isLabelChanged: PropTypes.bool
};
